import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { playTypeApi } from '../services/activityApi';
import { queryKeys } from '../utils/queryKeys';
import type { CreatePlayTypePayload, PlayTypeFormData } from '../types/play-type';

export function usePlayTypes() {
  return useQuery({
    queryKey: queryKeys.playTypes.list(),
    queryFn: () => playTypeApi.listPlayTypes(),
  });
}

/** Play types also appear in the activity filter options, so refresh those too */
function useInvalidatePlayTypes() {
  const queryClient = useQueryClient();
  return () => {
    queryClient.invalidateQueries({ queryKey: queryKeys.playTypes.all });
    queryClient.invalidateQueries({ queryKey: queryKeys.activities.filters() });
  };
}

export function useCreatePlayType() {
  const invalidate = useInvalidatePlayTypes();
  return useMutation({
    mutationFn: (payload: CreatePlayTypePayload) => playTypeApi.createPlayType(payload),
    onSuccess: invalidate,
  });
}

export function useUpdatePlayType() {
  const invalidate = useInvalidatePlayTypes();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: PlayTypeFormData }) => playTypeApi.updatePlayType(id, data),
    onSuccess: invalidate,
  });
}
